// extracted by mini-css-extract-plugin
export default {"obrigado":"Obrigado_obrigado__YVnIy","button":"Obrigado_button__uXb30"};